export enum DTableEvents {
  REQUEST_STARTED = '@dynamicTable/RequestStarted',
  REQUEST_ENDED = '@dynamicTable/RequestEnded',
  GET_FILTERS = '@dynamicTable/GetFilters',
  ON_FILTER = '@dynamicTable/OnFilter',
  CLEAR_ALL_FILTERS = '@dynamicTable/ClearAllFilters',
  REMOVE_FILTER = '@dynamicTable/RemoveFilter',
}
